export interface WhatIsNewContentDataInterface {
  title: string;
  description: string;
}

export const whatIsNewContentData: WhatIsNewContentDataInterface[] = [
  {
    title: `What's New in Logirate?`,
    description: `We have introduced new features and improvements to help you manage your drivers more effectively, giving you a much better experience. Take a quick tour to see what's new.`,
  },
  {
    title: `Introducing your centralized Dashboard`,
    description: `Stay updated on your driver activity, fleet status, incidents, and overall performance from one dashboard. Get a clear picture of what's happening across your operations and make informed decisions faster.`,
  },
  {
    title: `Log Bulk Trips`,
    description: `Easily upload multiple completed trips using our downloadable Excel template and build feedback insights that power your drivers performance data over time.`,
  },
  {
    title: `Rehire exited drivers`,
    description: `Rehire previously exited drivers quickly, with the option to update their information before reactivation`,
  },
  {
    title: `Driver Feedback Insights`,
    description: `Understand what customers are saying about your drivers through feedback and ratings. Get better visibility into driver performance and identify areas that need attention.`,
  },
  {
    title: `Settings`,
    description: `Your settings are now grouped into clear sections, so you can quickly find and manage what you need`,
  },
];
